import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs";
import { ResponseHttpSuccess } from "library";
import { AuthService } from "projects/store/src/app/services/api/v1/auth.service";
import { environment } from "projects/store/src/environments/environment";
import { TableDateFilters } from "projects/library/src/lib/services/table-filter.service";

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  url: string = environment.salesAPIURL;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getSalesReportSummary() {
    return this.http.get(`${this.url}user/me/sales-report/summary`, this.authService.getHttpOptionsBearer())
      .pipe(map((resp: any) => resp as ResponseHttpSuccess));
  }

  getSalesReportCredits(filters?: TableDateFilters) {
    let params = new HttpParams();

    if (filters) {
      params = params.set('filters', JSON.stringify(filters));
    }

    const httpOptions = {
      ...this.authService.getHttpOptionsBearer(),
      params
    };

    return this.http.get(`${this.url}user/me/sales-report/credits`, httpOptions)
      .pipe(map((resp: any) => resp as ResponseHttpSuccess));
  }

  getSalesReportCredit(contract: string) {
    return this.http.get(`${this.url}user/me/sales-report/credits/${contract}`, this.authService.getHttpOptionsBearer())
      .pipe(map((resp: any) => resp as ResponseHttpSuccess));
  }
}
